import { signalStore, withState } from "@ngrx/signals";
import { initialAuthenticationState } from "./auth.state";
import { withAuthenticationApiMethods } from "./auth.methods.api";
import { withAuthenticationStateMethods } from "./auth.methods.state";

export const AuthenticationStore = signalStore(
    { providedIn: 'root' },
    withState(initialAuthenticationState),
    withAuthenticationApiMethods,
    withAuthenticationStateMethods
);